import { defineTable } from "convex/server";
import { v } from "convex/values";
import {
  reportStatus,
  reportVisibility,
  reportFormat,
  reportConfigValidator,
  scheduleValidator,
  distributionValidator,
} from "./shared/validators";
import { internalControl } from "../../lib/shared/validators";

// ============= TABLA: REPORTS =============
export const validatorReport = v.object({
  // Internal Control (nuevo sistema)
  internalControl: internalControl,

  // Metadata básica
  title: v.string(),
  description: v.optional(v.string()),
  status: reportStatus,
  visibility: reportVisibility,

  // Configuración del reporte
  dataSource: v.string(), // "sales", "clients", "products", etc.
  config: reportConfigValidator,

  // Formato de salida
  format: reportFormat,

  // Programación (opcional)
  schedule: v.optional(scheduleValidator),

  // Control de ejecución
  lastRun: v.optional(v.number()),
  nextRun: v.number(),
  runCount: v.number(),

  // Distribución
  distribution: distributionValidator,

  // Destinatarios (solo si visibility === "assigned")
  assignedTo: v.optional(v.array(v.id("users"))),

  // Usuarios con acceso compartido (emails)
  sharedUsers: v.optional(v.array(v.string())),

  // IA (opcional)
  generatedByAI: v.optional(v.boolean()),
  aiPrompt: v.optional(v.string()),
});

export const reports = defineTable(validatorReport)
  // Índices obligatorios para performance
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_status", ["status"])
  .index("by_next_run", ["nextRun"]) // Para scheduler
  .index("by_company_and_status", ["internalControl.companyId", "status"])
  .index("by_branch_and_status", ["internalControl.branchId", "status"])
  // Nuevos índices con internalControl
  .index("by_internal_state", ["internalControl.state"])
  .index("by_internal_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .searchIndex("search_reports", {
    searchField: "title",
    filterFields: ["internalControl.companyId", "status", "visibility"],
  });
